import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { campaignsSelectors } from 'store/selectors/campaigns';
import { fetchTargetGroup } from 'store/actions/campaigns';

import Grid from 'material/components/Grid';

import { Backdrop, BreadcrumbsNavigation, Container, TargetsTable } from 'common/components';
import TopCard from 'common/containers/TopCard';
import { CardWrapper } from 'globalStyles';

const TargetGroupDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { organizationUuid, targetGroupUuid } = useParams();

  const { isDataFetching, targetGroupDetails } = useSelector(state => ({
    isDataFetching: campaignsSelectors.isDataFetching(state),
    targetGroupDetails: campaignsSelectors.getTargetGroupDetails(state),
  }));

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/campaigns`,
      name: 'Advocacy',
    },
    {
      link: `/${organizationUuid}/target-groups`,
      name: 'Target Groups',
    },
    {
      link: '',
      name: targetGroupDetails.name,
    },
  ];

  const { name, targets } = targetGroupDetails;

  useEffect(() => {
    dispatch(fetchTargetGroup(targetGroupUuid));
  }, []);

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <TopCard
            title={name}
            backButtonLink={`/${organizationUuid}/target-groups`}
            actionButtons={[
              {
                name: 'Edit',
                onClick: () =>
                  history.push(`/${organizationUuid}/create-target-group/${targetGroupUuid}`),
                variant: 'outlined',
              },
            ]}
          />
        </Grid>
        <CardWrapper>
          <TargetsTable targets={targets} hasStatistics={false} isDataFetching={isDataFetching} />
        </CardWrapper>
      </Container>
      <Backdrop isOpen={isDataFetching} />
    </>
  );
};

export default TargetGroupDetails;
